const svgProps = { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', height: '24', width: '24' }

// remake
const IcoAddOut = () => (
  <svg {...svgProps}>
    <path d='M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' />
  </svg>
)

const IcoArrDown = () => (
  <svg {...svgProps}>
    <path d='M8.11997 9.29006L12 13.1701L15.88 9.29006C16.27 8.90006 16.9 8.90006 17.29 9.29006C17.68 9.68006 17.68 10.3101 17.29 10.7001L12.7 15.2901C12.31 15.6801 11.68 15.6801 11.29 15.2901L6.69997 10.7001C6.30997 10.3101 6.30997 9.68006 6.69997 9.29006C7.08997 8.91006 7.72997 8.90006 8.11997 9.29006Z' />
  </svg>
)
// remake
const IcoArrows = () => (
  <svg {...svgProps}>
    <path d='M5.75 8.182a3 3 0 000 3.636l1.84 2.415c.76.998.05 2.434-1.205 2.434-.472 0-.918-.221-1.205-.597l-3.24-4.252a3 3 0 010-3.636L5.18 3.93a1.515 1.515 0 011.205-.597c1.254 0 1.965 1.436 1.206 2.434L5.75 8.182zM15.75 8.182a3 3 0 000 3.636l1.84 2.415c.76.998.05 2.434-1.205 2.434-.472 0-.918-.221-1.205-.597l-3.24-4.252a3 3 0 010-3.636l3.24-4.252a1.515 1.515 0 011.205-.597c1.254 0 1.965 1.436 1.206 2.434l-1.84 2.415z' />
  </svg>
)
// remake
function IcoApartment() {
  return (
    <svg {...svgProps}>
      <path d='M17,11V3H7v4H3v14h8v-4h2v4h8V11H17z M7,19H5v-2h2V19z M7,15H5v-2h2V15z M7,11H5V9h2V11z M11,15H9v-2h2V15z M11,11H9V9h2 V11z M11,7H9V5h2V7z M15,15h-2v-2h2V15z M15,11h-2V9h2V11z M15,7h-2V5h2V7z M19,19h-2v-2h2V19z M19,15h-2v-2h2V15z' />
    </svg>
  )
}

const IcoBackUp = () => (
  <svg {...svgProps}>
    <path d='M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z' />
  </svg>
)

const IcoBots = () => (
  <svg {...svgProps}>
    <path d='M21.2628 15.8306C21.5556 16.1235 21.5556 16.5983 21.2628 16.8912L18.654 19.5H20.3789C20.7931 19.5 21.1289 19.8358 21.1289 20.25C21.1289 20.6642 20.7931 21 20.3789 21L16.8433 21C16.4291 21 16.0933 20.6642 16.0933 20.25V16.7145C16.0933 16.3002 16.4291 15.9645 16.8433 15.9645C17.2575 15.9645 17.5933 16.3002 17.5933 16.7145V18.4393L20.2021 15.8306C20.495 15.5377 20.9699 15.5377 21.2628 15.8306Z' />
    <path d='M2.81293 7.78034C3.10583 8.07323 3.5807 8.07323 3.87359 7.78034L6.48235 5.17158L6.48235 6.89645C6.48235 7.31067 6.81814 7.64645 7.23235 7.64645C7.64656 7.64645 7.98235 7.31067 7.98235 6.89645L7.98235 3.36092C7.98235 3.16201 7.90333 2.97124 7.76268 2.83059C7.62203 2.68994 7.43126 2.61092 7.23235 2.61092L3.69682 2.61092C3.2826 2.61092 2.94682 2.9467 2.94682 3.36092C2.94682 3.77513 3.2826 4.11092 3.69682 4.11092H5.42169L2.81293 6.71968C2.52004 7.01257 2.52004 7.48744 2.81293 7.78034Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.46203 20.5622C8.66377 20.5827 8.86846 20.5932 9.07561 20.5932C12.3893 20.5932 15.0756 17.9069 15.0756 14.5932C18.3893 14.5932 21.0756 11.9069 21.0756 8.59315C21.0756 5.69362 19.0189 3.27448 16.2847 2.71504C15.9185 2.64011 15.5402 2.59853 15.153 2.59363C15.1272 2.5933 15.1014 2.59314 15.0755 2.59314C11.7618 2.59314 9.07549 5.27943 9.07549 8.59314C5.76179 8.59314 3.07549 11.2794 3.07549 14.5931C3.07549 17.5962 5.28172 20.0839 8.16175 20.524C8.26107 20.5392 8.36118 20.5519 8.46203 20.5622ZM5.07549 14.5931C5.07549 12.384 6.86636 10.5931 9.07549 10.5931C9.19246 10.5931 9.30806 10.5981 9.42214 10.6079C10.0255 12.3008 11.3678 13.6431 13.0607 14.2465C13.0705 14.3606 13.0755 14.4762 13.0755 14.5931C13.0755 16.8023 11.2846 18.5931 9.07549 18.5931C6.86636 18.5931 5.07549 16.8023 5.07549 14.5931ZM11.0755 8.59314C11.0755 6.384 12.8664 4.59314 15.0755 4.59314C17.2846 4.59314 19.0755 6.384 19.0755 8.59314C19.0755 10.8023 17.2846 12.5931 15.0755 12.5931C12.8664 12.5931 11.0755 10.8023 11.0755 8.59314Z'
    />
  </svg>
)

const IcoCaution = () => (
  <svg {...svgProps}>
    <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' />
  </svg>
)

const IcoClose = () => (
  <svg {...svgProps}>
    <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' />
  </svg>
)

const IcoCheck2 = () => (
  <svg {...svgProps}>
    <path d='M23.4142 6.58991L10.3089 20.3839C9.93332 20.7792 9.42589 21 8.89649 21C8.36709 21 7.85766 20.7792 7.48408 20.3839L0.585841 13.1231C-0.19528 12.301 -0.19528 10.972 0.585841 10.1498C1.36696 9.32768 2.62954 9.32768 3.41066 10.1498L8.89649 15.924L20.5893 3.61663C21.3705 2.79446 22.633 2.79446 23.4142 3.61663C24.1953 4.4388 24.1953 5.76773 23.4142 6.58991Z' />
  </svg>
)
const IcoCheck = () => (
  <svg {...svgProps}>
    <path d='M 20.042 0.035 C 19.999 0.059 18.159 2.406 14.603 6.978 C 11.646 10.776 9.219 13.88 9.208 13.876 C 9.193 13.868 7.77 12.14 4.755 8.468 C 4.397 8.029 4.069 7.646 4.029 7.617 C 3.938 7.545 3.825 7.542 3.69 7.602 C 3.563 7.66 3.621 7.588 1.637 10.191 C 0.578 11.581 0.056 12.283 0.034 12.348 C -0.009 12.466 -0.011 12.548 0.028 12.671 C 0.051 12.745 0.589 13.413 2.563 15.82 C 4.761 18.5 5.312 19.185 7.029 21.388 C 9.038 23.964 9.066 23.998 9.204 24 C 9.231 24 9.274 23.981 9.3 23.957 C 9.448 23.831 13.239 19.009 18.238 12.591 C 22.706 6.85 23.916 5.286 23.951 5.192 C 24.002 5.062 24.009 4.954 23.978 4.804 C 23.961 4.72 23.715 4.395 22.164 2.399 C 20.951 0.84 20.346 0.076 20.293 0.045 C 20.203 -0.013 20.132 -0.016 20.042 0.035 Z' />
  </svg>
)
// remake
const IcoDescription = () => (
  <svg {...svgProps}>
    <path d='M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z' />
  </svg>
)

const IcoDocument = () => (
  <svg {...svgProps}>
    <path
      fillRule='evenodd'
      d='M2 4C2 1.79086 3.79086 0 6 0H18C20.2091 0 22 1.79086 22 4V20C22 22.2091 20.2091 24 18 24H6C3.79086 24 2 22.2091 2 20V4ZM19 10L5 10L5 8L19 8V10ZM5 6L19 6V4L5 4L5 6ZM19 14L5 14L5 12L19 12V14ZM5 18H13.5817C14.2857 17 15 16 15 16L5 16L5 18Z'
    />
  </svg>
)

// remake
const IcoError = () => (
  <svg {...svgProps}>
    <path d='M 16.549 12 L 23.372 5.177 C 24.209 4.34 24.209 2.981 23.372 2.145 L 21.856 0.628 C 21.018 -0.209 19.661 -0.209 18.823 0.628 L 12 7.451 L 5.177 0.628 C 4.34 -0.209 2.982 -0.209 2.144 0.628 L 0.628 2.145 C -0.209 2.981 -0.209 4.34 0.628 5.177 L 7.451 12 L 0.628 18.823 C -0.209 19.66 -0.209 21.018 0.628 21.855 L 2.144 23.372 C 2.982 24.209 4.34 24.209 5.177 23.372 L 12 16.549 L 18.823 23.372 C 19.66 24.209 21.018 24.209 21.856 23.372 L 23.372 21.855 C 24.209 21.019 24.209 19.661 23.372 18.823 L 16.549 12 Z' />
  </svg>
)

// remake
const IcoFolderOut = () => (
  <svg {...svgProps}>
    <path d='M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' />
  </svg>
)

const IcoGitHub = () => (
  <svg height='32' width='32' viewBox='0 0 16 16'>
    <path d='M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z' />
  </svg>
)

const IcoKey = () => (
  <svg {...svgProps}>
    <path d='M8.97903 8.00765C6.69956 8.15234 4.95126 10.3164 5.40579 12.7826C5.6958 14.357 6.93028 15.6274 8.46144 15.9257C10.5433 16.3316 12.4 15.0283 12.9462 13.1431H15.3334V13.7146C15.3334 14.346 15.8306 14.8575 16.4445 14.8575C17.0584 14.8575 17.5557 14.346 17.5557 13.7146V13.1431C18.1696 13.1431 18.6668 12.6316 18.6668 12.0002C18.6668 11.3687 18.1696 10.8572 17.5557 10.8572H12.944C12.5441 9.45324 11.3941 8.34959 9.98275 8.07462C9.64031 8.00783 9.30467 7.98698 8.97903 8.00765ZM9.2221 10.2857C10.1427 10.2857 10.8888 11.0532 10.8888 12.0002C10.8888 12.9471 10.1427 13.7146 9.2221 13.7146C8.30151 13.7146 7.55538 12.9471 7.55538 12.0002C7.55538 11.0532 8.30151 10.2857 9.2221 10.2857Z' />
    <path
      fillRule='evenodd'
      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
    />
  </svg>
)

// remake
const IcoLanguages = () => (
  <svg {...svgProps}>
    <path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z' />
  </svg>
)

const IcoLogout = () => (
  <svg {...svgProps}>
    <path d='M18.6343 6.64267C19.0574 6.28767 19.6882 6.34285 20.0432 6.76593L23.7517 11.1856C23.9023 11.365 23.9791 11.5819 23.9853 11.7992C24.036 12.0812 23.9658 12.3829 23.7672 12.6196L20.0753 17.0194C19.7203 17.4425 19.0895 17.4977 18.6664 17.1427C18.2434 16.7877 18.1882 16.1569 18.5432 15.7338L20.8372 12.9999H11C10.4477 12.9999 10 12.5522 10 11.9999C10 11.4476 10.4477 10.9999 11 10.9999H20.9851L18.5111 8.0515C18.1561 7.62843 18.2113 6.99767 18.6343 6.64267Z' />
    <path d='M10.9512 3C6.0122 3 2 7.02482 2 12C2 16.9752 6.0122 21 10.9512 21C12.3528 21 13.6765 20.6768 14.8554 20.1014C15.3517 19.8591 15.9504 20.065 16.1927 20.5613C16.435 21.0576 16.2291 21.6563 15.7328 21.8986C14.2869 22.6045 12.6637 23 10.9512 23C4.89842 23 0 18.0705 0 12C0 5.92948 4.89842 1 10.9512 1C12.6637 1 14.2869 1.39553 15.7328 2.10137C16.2291 2.34365 16.435 2.9424 16.1927 3.4387C15.9504 3.935 15.3517 4.14092 14.8554 3.89863C13.6765 3.32316 12.3528 3 10.9512 3Z' />
  </svg>
)

const IcoLogout2 = () => (
  <svg {...svgProps}>
    <path d='M16.3 8.09014C15.91 8.48014 15.91 9.10014 16.3 9.49014L18.2 11.3901H9C8.45 11.3901 8 11.8401 8 12.3901C8 12.9401 8.45 13.3901 9 13.3901H18.2L16.3 15.2901C15.91 15.6801 15.91 16.3001 16.3 16.6901C16.69 17.0801 17.31 17.0801 17.7 16.6901L21.29 13.1001C21.68 12.7101 21.68 12.0801 21.29 11.6901L17.7 8.09014C17.31 7.70014 16.69 7.70014 16.3 8.09014ZM4 19.3901H11C11.55 19.3901 12 19.8401 12 20.3901C12 20.9401 11.55 21.3901 11 21.3901H4C2.9 21.3901 2 20.4901 2 19.3901V5.39014C2 4.29014 2.9 3.39014 4 3.39014H11C11.55 3.39014 12 3.84014 12 4.39014C12 4.94014 11.55 5.39014 11 5.39014H4V19.3901Z' />
  </svg>
)

const IcoMenu = () => (
  <svg {...svgProps}>
    <path d='M0 4C0 2.89543 0.89543 2 2 2H22C23.1046 2 24 2.89543 24 4C24 5.10457 23.1046 6 22 6H2C0.895431 6 0 5.10457 0 4ZM0 12C0 10.8954 0.89543 10 2 10H22C23.1046 10 24 10.8954 24 12C24 13.1046 23.1046 14 22 14H2C0.895431 14 0 13.1046 0 12ZM24 20C24 18.8954 23.1046 18 22 18H2C0.895431 18 0 18.8954 0 20C0 21.1046 0.89543 22 2 22H22C23.1046 22 24 21.1046 24 20Z' />
  </svg>
)

const IcoMetamask = () => (
  <svg viewBox='0 0 40 40'>
    <path d='M36.0112 3.33337L22.1207 13.6277L24.7012 7.56091L36.0112 3.33337Z' fill='#E17726' />
    <path d='M4.00261 3.33337L17.7558 13.7238L15.2989 7.56091L4.00261 3.33337Z' fill='#E27625' />
    <path d='M31.0149 27.2023L27.3227 32.8573L35.2287 35.0397L37.4797 27.3258L31.0149 27.2023Z' fill='#E27625' />
    <path d='M2.53386 27.3258L4.77116 35.0397L12.6772 32.8573L8.9987 27.2023L2.53386 27.3258Z' fill='#E27625' />
    <path d='M12.2518 17.6496L10.0419 20.9712L17.8793 21.3281L17.6048 12.8867L12.2518 17.6496Z' fill='#E27625' />
    <path d='M27.762 17.6494L22.3129 12.7905L22.1207 21.3279L29.9581 20.9711L27.762 17.6494Z' fill='#E27625' />
    <path d='M12.6772 32.8574L17.3989 30.5652L13.336 27.3809L12.6772 32.8574Z' fill='#E27625' />
    <path d='M22.6009 30.5652L27.3226 32.8574L26.6637 27.3809L22.6009 30.5652Z' fill='#E27625' />
    <path d='M27.3226 32.8575L22.6009 30.5653L22.9715 33.6399L22.9303 34.9301L27.3226 32.8575Z' fill='#D5BFB2' />
    <path d='M12.6772 32.8575L17.0694 34.9301L17.042 33.6399L17.3989 30.5653L12.6772 32.8575Z' fill='#D5BFB2' />
    <path d='M17.1518 25.3495L13.2262 24.1965L15.9988 22.92L17.1518 25.3495Z' fill='#233447' />
    <path d='M22.848 25.3495L24.001 22.92L26.801 24.1965L22.848 25.3495Z' fill='#233447' />
    <path d='M12.6773 32.8573L13.3635 27.2023L8.99876 27.3258L12.6773 32.8573Z' fill='#CC6228' />
    <path d='M26.6364 27.2023L27.3227 32.8573L31.0149 27.3258L26.6364 27.2023Z' fill='#CC6228' />
    <path
      d='M29.9581 20.9709L22.1207 21.3278L22.8482 25.3495L24.0011 22.92L26.8012 24.1965L29.9581 20.9709Z'
      fill='#CC6228'
    />
    <path
      d='M13.2263 24.1965L15.9989 22.92L17.1519 25.3495L17.8793 21.3278L10.0419 20.9709L13.2263 24.1965Z'
      fill='#CC6228'
    />
    <path d='M10.0419 20.9709L13.3361 27.3809L13.2263 24.1965L10.0419 20.9709Z' fill='#E27525' />
    <path d='M26.8011 24.1965L26.6638 27.3809L29.958 20.9709L26.8011 24.1965Z' fill='#E27525' />
    <path d='M17.8793 21.3278L17.1519 25.3494L18.0715 30.0985L18.2637 23.8396L17.8793 21.3278Z' fill='#E27525' />
    <path d='M22.1205 21.3278L21.7499 23.8258L21.9283 30.0985L22.848 25.3494L22.1205 21.3278Z' fill='#E27525' />
    <path
      d='M22.848 25.3496L21.9284 30.0987L22.601 30.5654L26.6638 27.381L26.8011 24.1967L22.848 25.3496Z'
      fill='#F5841F'
    />
    <path
      d='M13.2262 24.1967L13.336 27.381L17.3989 30.5654L18.0714 30.0987L17.1518 25.3496L13.2262 24.1967Z'
      fill='#F5841F'
    />
    <path
      d='M22.9303 34.93L22.9715 33.6398L22.6284 33.3378H17.3714L17.042 33.6398L17.0694 34.93L12.6772 32.8574L14.2145 34.1202L17.3302 36.2751H22.6696L25.7853 34.1202L27.3226 32.8574L22.9303 34.93Z'
      fill='#C0AC9D'
    />
    <path
      d='M22.601 30.5653L21.9284 30.0986H18.0715L17.3989 30.5653L17.0421 33.6399L17.3715 33.3379H22.6285L22.9716 33.6399L22.601 30.5653Z'
      fill='#161616'
    />
    <path
      d='M36.5875 14.3003L37.7542 8.61779L36.011 3.33337L22.6009 13.2846L27.7618 17.6493L35.0365 19.7768L36.6424 17.8964L35.9424 17.3886L37.0679 16.3728L36.2169 15.7003L37.3287 14.863L36.5875 14.3003Z'
      fill='#763E1A'
    />
    <path
      d='M2.24573 8.61779L3.42615 14.3003L2.67123 14.863L3.78302 15.7003L2.93202 16.3728L4.05753 17.3886L3.35752 17.8964L4.96343 19.7768L12.2518 17.6493L17.399 13.2846L4.00263 3.33337L2.24573 8.61779Z'
      fill='#763E1A'
    />
    <path
      d='M35.0365 19.777L27.7619 17.6495L29.958 20.9712L26.6638 27.3811L31.0149 27.3262H37.4797L35.0365 19.777Z'
      fill='#F5841F'
    />
    <path
      d='M12.2517 17.6495L4.96332 19.777L2.53386 27.3262H8.99869L13.336 27.3811L10.0419 20.9712L12.2517 17.6495Z'
      fill='#F5841F'
    />
    <path
      d='M22.1205 21.3276L22.6009 13.2843L24.701 7.56067H15.2988L17.3988 13.2843L17.8792 21.3276L18.0577 23.8531L18.0714 30.0984H21.9283L21.9421 23.8531L22.1205 21.3276Z'
      fill='#F5841F'
    />
  </svg>
)

const IcoMoney = () => (
  <svg {...svgProps}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.4063 19.9329C12.066 19.9329 12.6742 19.779 13.207 19.5106V21.6632C12.6449 21.8378 12.0415 21.9329 11.4063 21.9329H7.00792C2.52538 21.9329 -0.374267 17.1964 1.66429 13.2043L3.70684 9.20426C4.30576 8.03138 5.25922 7.11243 6.39803 6.55101L5.46396 4.68288C5.08785 3.93066 5.54693 3.02913 6.3765 2.89087L11.6153 2.01773C12.5647 1.8595 13.3292 2.78847 12.9912 3.68962L11.9333 6.51092C13.1087 7.06815 14.094 8.00302 14.7074 9.20426L16.6114 12.9329H14.3657L12.9261 10.1138C12.2427 8.77534 10.8666 7.93292 9.36372 7.93292H9.05047C7.54759 7.93292 6.17153 8.77534 5.48805 10.1138L3.4455 14.1138C2.08646 16.7753 4.01956 19.9329 7.00792 19.9329H11.4063ZM10.6623 4.20415L7.70695 4.69671L8.32504 5.93291H10.014L10.6623 4.20415Z'
    />
    <path d='M14.707 13.9329C14.4309 13.9329 14.207 14.1568 14.207 14.4329V15.4329C14.207 15.7091 14.4309 15.9329 14.707 15.9329H20.707C20.9832 15.9329 21.207 15.7091 21.207 15.4329V14.4329C21.207 14.1568 20.9832 13.9329 20.707 13.9329H14.707Z' />
    <path d='M15.207 17.4329C15.207 17.1568 15.4309 16.9329 15.707 16.9329H21.707C21.9832 16.9329 22.207 17.1568 22.207 17.4329V18.4329C22.207 18.7091 21.9832 18.9329 21.707 18.9329H15.707C15.4309 18.9329 15.207 18.7091 15.207 18.4329V17.4329Z' />
    <path d='M14.707 19.9329C14.4309 19.9329 14.207 20.1568 14.207 20.4329V21.4329C14.207 21.7091 14.4309 21.9329 14.707 21.9329L20.707 21.9329C20.9832 21.9329 21.207 21.7091 21.207 21.4329V20.4329C21.207 20.1568 20.9832 19.9329 20.707 19.9329L14.707 19.9329Z' />
    <path d='M9.9212 9.93292C9.9212 9.51871 9.58541 9.18292 9.1712 9.18292C8.75699 9.18292 8.4212 9.51871 8.4212 9.93292V10.2471C7.4372 10.4874 6.70692 11.3749 6.70692 12.4329C6.70692 13.6756 7.71427 14.6829 8.95691 14.6829H9.64423C10.0043 14.6829 10.3136 14.9388 10.381 15.2926C10.469 15.7548 10.1147 16.1829 9.64423 16.1829H8.89883C8.62969 16.1829 8.38118 16.0387 8.24765 15.805L8.1081 15.5608C7.90259 15.2012 7.44445 15.0762 7.08481 15.2817C6.72517 15.4872 6.60023 15.9454 6.80573 16.305L6.94528 16.5492C7.26526 17.1092 7.80531 17.4979 8.4212 17.6317V17.9329C8.4212 18.3471 8.75699 18.6829 9.1712 18.6829C9.58541 18.6829 9.9212 18.3471 9.9212 17.9329V17.6662C11.1913 17.5114 12.101 16.3061 11.8545 15.0119C11.6524 13.9507 10.7245 13.1829 9.64423 13.1829H8.95691C8.5427 13.1829 8.20692 12.8471 8.20692 12.4329C8.20692 12.0187 8.5427 11.6829 8.95691 11.6829H9.44357C9.71272 11.6829 9.96123 11.8271 10.0948 12.0608L10.2343 12.305C10.4398 12.6647 10.898 12.7896 11.2576 12.5841C11.6172 12.3786 11.7422 11.9205 11.5367 11.5608L11.3971 11.3166C11.0771 10.7566 10.5371 10.3679 9.9212 10.2341V9.93292Z'></path>
  </svg>
)

const IcoMore = () => (
  <svg {...svgProps}>
    <path d='M12 4C10.8954 4 10 3.10457 10 2C10 0.89543 10.8954 -4.82814e-08 12 0C13.1046 4.82832e-08 14 0.895431 14 2C14 3.10457 13.1046 4 12 4Z' />
    <path d='M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z' />
    <path d='M12 24C10.8954 24 10 23.1046 10 22C10 20.8954 10.8954 20 12 20C13.1046 20 14 20.8954 14 22C14 23.1046 13.1046 24 12 24Z' />
  </svg>
)

const IcoMoon = () => (
  <svg viewBox='0 0 499.712 499.712' width='24' height='24'>
    <path
      fill='#FFD93B'
      d='M146.88,375.528c126.272,0,228.624-102.368,228.624-228.64c0-55.952-20.16-107.136-53.52-146.88
	C425.056,33.096,499.696,129.64,499.696,243.704c0,141.392-114.608,256-256,256c-114.064,0-210.608-74.64-243.696-177.712
	C39.744,355.368,90.944,375.528,146.88,375.528z'
    />
    <path
      fill='#F4C534'
      d='M401.92,42.776c34.24,43.504,54.816,98.272,54.816,157.952c0,141.392-114.608,256-256,256
	c-59.68,0-114.448-20.576-157.952-54.816c46.848,59.472,119.344,97.792,200.928,97.792c141.392,0,256-114.608,256-256
	C499.712,162.12,461.392,89.64,401.92,42.776z'
    />
    <g>
      <polygon
        fill='#FFD83B'
        points='128.128,99.944 154.496,153.4 213.472,161.96 170.8,203.56 180.864,262.296 
		128.128,234.568 75.376,262.296 85.44,203.56 42.768,161.96 101.744,153.4 	'
      />
      <polygon
        fill='#FFD83B'
        points='276.864,82.84 290.528,110.552 321.104,114.984 298.976,136.552 304.208,166.984 
		276.864,152.616 249.52,166.984 254.752,136.552 232.624,114.984 263.2,110.552 	'
      />
    </g>
  </svg>
)

// remake
const IcoNotification = () => (
  <svg {...svgProps}>
    <path d='M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z' />
  </svg>
)

const IcoSplash = () => (
  <svg {...svgProps}>
    <rect x='13' y='12' width='7' height='2' rx='1' />
    <rect x='8' y='9' width='7' height='7' rx='3.5' />
    <rect x='1' y='17' width='6' height='6' rx='3' />
    <rect x='20' width='4' height='4' rx='2' />
    <rect x='17' y='11' width='4' height='4' rx='2' />
    <rect x='17' y='18' width='5' height='5' rx='2.5' />
    <rect y='1' width='6' height='6' rx='3' />
    <rect x='14.4238' y='8.35547' width='8.98825' height='2' rx='1' transform='rotate(-45 14.4238 8.35547)' />
    <rect x='2.26855' y='20.6011' width='12.2651' height='2' rx='1' transform='rotate(-45 2.26855 20.6011)' />
    <rect
      width='6.87291'
      height='2'
      rx='1'
      transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 17.6606 17.2461)'
    />
    <rect width='10.4824' height='2' rx='1' transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 11.291 10.877)' />
  </svg>
)

// remake
const IcoSearch = () => (
  <svg {...svgProps}>
    <path d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
  </svg>
)

const IcoSettings = () => (
  <svg {...svgProps}>
    <path d='M23.6653 13.0188L21.8245 13.5447C21.6581 13.5934 21.5329 13.7313 21.5004 13.9016V13.9016C21.4187 14.308 21.3106 14.7086 21.1769 15.1009C21.1194 15.2649 21.1589 15.4472 21.2791 15.5727L22.6119 16.9501C22.7553 17.0983 22.7831 17.3237 22.68 17.5023L22.1054 18.4976C22.0023 18.6763 21.7932 18.7649 21.5931 18.7147L19.7238 18.2467H19.7238C19.5555 18.2055 19.3782 18.2621 19.2648 18.3931C18.9932 18.7021 18.7025 18.9937 18.3942 19.2662C18.2632 19.3795 18.2066 19.5567 18.2477 19.725L18.7151 21.5927C18.7652 21.7927 18.6767 22.0018 18.4981 22.105L17.5026 22.6796C17.324 22.7828 17.0986 22.755 16.9504 22.6115L15.5661 21.2722C15.4407 21.152 15.2584 21.1123 15.0944 21.1697C14.7047 21.3032 14.3068 21.4115 13.9032 21.4938C13.7331 21.5265 13.5955 21.6515 13.5467 21.8177L13.0191 23.6649C12.9623 23.8633 12.781 24 12.5748 24H11.4255C11.2192 24 11.0379 23.8633 10.9812 23.6649L10.4538 21.8182C10.4051 21.6517 10.2672 21.5265 10.0968 21.494H10.0968C9.69229 21.4127 9.29343 21.3053 8.90275 21.1726C8.73889 21.1153 8.55676 21.1549 8.43146 21.2751L7.05009 22.6115C6.90186 22.755 6.67645 22.7828 6.49781 22.6796L5.50253 22.105C5.32399 22.0018 5.23547 21.7928 5.2856 21.5927L5.75393 19.7224C5.79515 19.5538 5.73843 19.3763 5.60707 19.2629H5.60707C5.29758 18.9918 5.00554 18.7014 4.73271 18.3935C4.61933 18.2628 4.44242 18.2064 4.27435 18.2475L2.40767 18.7148C2.20756 18.7649 1.99849 18.6763 1.89535 18.4976L1.32035 17.5023C1.21722 17.3237 1.245 17.0983 1.38843 16.9501L2.72396 15.5701C2.84428 15.4445 2.88383 15.262 2.82628 15.098V15.098C2.69184 14.7066 2.58287 14.3069 2.50006 13.9015C2.46745 13.7313 2.34243 13.5937 2.1762 13.545L0.335037 13.0189C0.136668 12.9622 -7.65847e-05 12.7809 3.21794e-08 12.5746V11.4253V11.4253C-7.12197e-05 11.219 0.136678 11.0377 0.335048 10.9811L2.17584 10.4549C2.34228 10.4061 2.4674 10.2683 2.49984 10.0979V10.0979C2.58171 9.69156 2.68983 9.29097 2.82353 8.89862C2.88098 8.73467 2.84143 8.55234 2.7212 8.42693L1.38842 7.04978C1.245 6.90154 1.21722 6.67618 1.32035 6.49754L1.89493 5.50223C1.99814 5.32368 2.2072 5.23516 2.40724 5.2853L4.27683 5.75335C4.4452 5.79451 4.62243 5.73796 4.73584 5.60691L4.73584 5.60691C5.00737 5.29785 5.29812 5.00624 5.60637 4.73381C5.7374 4.6205 5.79396 4.44335 5.75282 4.27508L5.28518 2.40736C5.235 2.20731 5.32353 1.99824 5.5021 1.89505L6.49739 1.32043C6.67603 1.21728 6.9014 1.24504 7.04967 1.38846L8.43399 2.72785C8.55942 2.84807 8.74174 2.88767 8.90574 2.83031L8.90574 2.83031C9.29541 2.69687 9.69325 2.58862 10.0968 2.50622C10.2669 2.47359 10.4045 2.34855 10.4533 2.18231L10.981 0.335079C11.0378 0.13675 11.219 2.26156e-05 11.4253 0H12.5746C12.7809 3.83018e-05 12.9621 0.136759 13.0189 0.335079L13.5465 2.18189C13.5952 2.34839 13.7331 2.47358 13.9035 2.50608V2.50608C14.308 2.58738 14.7069 2.69475 15.0976 2.8275C15.2615 2.88465 15.4435 2.84505 15.5689 2.72499L16.9502 1.38855C17.0984 1.24506 17.3238 1.21726 17.5024 1.32042L18.4977 1.89504C18.6763 1.99822 18.7648 2.20731 18.7146 2.40736L18.2464 4.27771C18.2052 4.44628 18.2619 4.62373 18.3933 4.73713C18.7027 5.00824 18.9947 5.29863 19.2676 5.60658C19.3809 5.73729 19.5578 5.79365 19.7259 5.75257L21.5927 5.2853C21.7927 5.23511 22.0018 5.32364 22.105 5.50223L22.6795 6.49754C22.7827 6.67616 22.7549 6.90154 22.6115 7.04978L21.276 8.43002C21.1557 8.55554 21.1161 8.73802 21.1737 8.90208C21.3081 9.29348 21.4171 9.69316 21.4998 10.0986C21.5325 10.2687 21.6575 10.4063 21.8237 10.455L23.6649 10.9812C23.8633 11.0379 24 11.2192 24 11.4255V12.5747V12.5747C24 12.7808 23.8635 12.962 23.6654 13.0188L23.6653 13.0188ZM7.67641 6.35723C7.61214 6.24537 7.46936 6.20679 7.3575 6.27106C7.34746 6.27683 7.33785 6.28334 7.32877 6.29054H7.32877C4.17559 8.8585 3.7012 13.4964 6.26918 16.6495C6.58543 17.0378 6.94046 17.3929 7.32877 17.7091C7.4299 17.7892 7.57685 17.7722 7.65699 17.6711C7.66416 17.662 7.67065 17.6525 7.67641 17.6425L10.3349 13.0382C10.7059 12.3956 10.7059 11.6039 10.3349 10.9613L7.67641 6.35723ZM12 4.61487C11.1065 4.6139 10.2203 4.7755 9.38469 5.09178C9.26547 5.13902 9.20711 5.27397 9.25436 5.39319C9.25865 5.40403 9.26375 5.41452 9.26963 5.42459L11.9333 10.0382C12.3043 10.6808 12.99 11.0767 13.732 11.0767H19.0517C19.1807 11.0768 19.2854 10.9722 19.2855 10.8432C19.2855 10.8317 19.2847 10.8203 19.283 10.809C18.701 7.23868 15.6175 4.61611 12 4.61487H12ZM19.0515 12.9226H13.7322C12.9902 12.9226 12.3045 13.3185 11.9335 13.9611L9.26986 18.5747C9.20527 18.6855 9.24272 18.8276 9.35351 18.8922C9.36358 18.8981 9.37408 18.9032 9.38492 18.9075H9.38492C13.1994 20.3494 17.4606 18.426 18.9025 14.6115C19.0763 14.1516 19.2038 13.6755 19.283 13.1903C19.3016 13.0626 19.2131 12.944 19.0854 12.9254C19.0743 12.9238 19.063 12.923 19.0517 12.923L19.0515 12.9226Z' />
  </svg>
)

const IcoSettingsMob = () => (
  <svg {...svgProps}>
    <rect x='3' width='2' height='14' rx='1' />
    <rect x='3' y='18' width='2' height='6' rx='1' />
    <rect x='19' y='20' width='2' height='4' rx='1' />
    <rect x='11' y='8' width='2' height='16' rx='1' />
    <rect x='11' width='2' height='4' rx='1' />
    <rect x='8' y='5' width='8' height='4' rx='2' />
    <rect y='15' width='8' height='4' rx='2' />
    <rect x='16' y='15' width='8' height='4' rx='2' />
    <rect x='19' width='2' height='16' rx='1' />
  </svg>
)

const IcoSorting = () => (
  <svg {...svgProps}>
    <path
      fillRule='evenodd'
      d='M22.5 4H10.7439C10.1262 2.25221 8.45933 1 6.5 1C4.54067 1 2.87381 2.25221 2.25606 4H1.5C0.671573 4 0 4.67157 0 5.5C0 6.32843 0.671573 7 1.5 7H2.25606C2.87381 8.74779 4.54067 10 6.5 10C8.45933 10 10.1262 8.74779 10.7439 7H22.5C23.3284 7 24 6.32843 24 5.5C24 4.67157 23.3284 4 22.5 4ZM1.5 17C0.671573 17 0 17.6716 0 18.5C0 19.3284 0.671573 20 1.5 20H13.2561C13.8738 21.7478 15.5407 23 17.5 23C19.4593 23 21.1262 21.7478 21.7439 20H22.5C23.3284 20 24 19.3284 24 18.5C24 17.6716 23.3284 17 22.5 17H21.7439C21.1262 15.2522 19.4593 14 17.5 14C15.5407 14 13.8738 15.2522 13.2561 17H1.5ZM20 18.5C20 19.8807 18.8807 21 17.5 21C16.1193 21 15 19.8807 15 18.5C15 17.1193 16.1193 16 17.5 16C18.8807 16 20 17.1193 20 18.5ZM6.5 8C7.88071 8 9 6.88071 9 5.5C9 4.11929 7.88071 3 6.5 3C5.11929 3 4 4.11929 4 5.5C4 6.88071 5.11929 8 6.5 8Z'
    />
  </svg>
)

const IcoStatistic = () => (
  <svg {...svgProps}>
    <rect x='1' y='22' width='24' height='2' rx='1' />
    <rect x='19' y='12' width='6' height='2' rx='1' />
    <rect x='10' y='12' width='3' height='2' rx='1' />
    <rect x='1' y='12' width='3' height='2' rx='1' />
    <rect x='14.1201' y='12.5283' width='12.416' height='2' rx='1' transform='rotate(-45 14.1201 12.5283)' />
    <rect x='0.583008' y='17.8608' width='15.3723' height='2' rx='1' transform='rotate(-45 0.583008 17.8608)' />
    <rect
      width='7.83407'
      height='2'
      rx='1'
      transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 16.9536 12.5396)'
    />
    <path d='M20 4C20 3.44771 20.4477 3 21 3L24 3C24.5523 3 25 3.44772 25 4C25 4.55229 24.5523 5 24 5L21 5C20.4477 5 20 4.55228 20 4Z' />
    <rect x='23' y='8' width='5' height='2' rx='1' transform='rotate(-90 23 8)' />
  </svg>
)

// remake
const IcoStorage = () => (
  <svg {...svgProps}>
    <path d='M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' />
  </svg>
)

// remake
const IcoSubject = () => (
  <svg {...svgProps}>
    <path d='M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' />
  </svg>
)

// remake
const IcoSuccess = () => (
  <svg {...svgProps}>
    <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' />
  </svg>
)

const IcoTultip = () => (
  <svg {...svgProps}>
    <path d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM13.3563 14.4459C13.4384 14.3655 13.4844 14.2565 13.4844 14.1429C13.4844 13.1804 14.0275 12.5958 14.609 11.9698C15.279 11.2485 16 10.4723 16 9C16 7.34309 14.4331 6 12.5001 6C10.5671 6 9.0002 7.34311 9.0002 9C8.99668 9.32803 9.03911 9.65498 9.12632 9.97171C9.15227 10.0623 9.20778 10.142 9.28437 10.1987C9.36095 10.2554 9.45439 10.286 9.55039 10.2857H10.4388C10.5084 10.2857 10.577 10.2695 10.6388 10.2382C10.7006 10.2069 10.7539 10.1616 10.7942 10.106C10.8344 10.0505 10.8605 9.98625 10.8702 9.91877C10.88 9.85128 10.8731 9.7825 10.8501 9.71817C10.7752 9.48604 10.7398 9.24339 10.7455 9C10.7455 8.28994 11.5723 7.71429 12.418 7.71429C13.2637 7.71429 14.0859 8.28991 14.0859 9C14.0859 9.99075 13.556 10.5562 12.9879 11.1624C12.3319 11.8624 11.625 12.6167 11.625 14.1429C11.625 14.2565 11.6711 14.3655 11.7532 14.4459C11.8352 14.5263 11.9465 14.5714 12.0625 14.5714H13.047C13.163 14.5714 13.2743 14.5263 13.3563 14.4459ZM13.1482 15.9069C12.9564 15.7813 12.7308 15.7143 12.5001 15.7143C12.3469 15.7143 12.1952 15.7438 12.0536 15.8013C11.9121 15.8587 11.7835 15.9429 11.6752 16.049C11.5668 16.1551 11.4809 16.2811 11.4223 16.4198C11.3636 16.5584 11.3335 16.7071 11.3335 16.8571C11.3335 17.0832 11.4019 17.3041 11.5301 17.4921C11.6583 17.68 11.8405 17.8265 12.0536 17.913C12.2668 17.9995 12.5014 18.0221 12.7277 17.978C12.954 17.9339 13.1619 17.8251 13.325 17.6653C13.4882 17.5054 13.5993 17.3018 13.6443 17.0801C13.6893 16.8584 13.6662 16.6286 13.5779 16.4198C13.4896 16.211 13.3401 16.0325 13.1482 15.9069Z' />
  </svg>
)

const IcoUser = () => (
  <svg {...svgProps}>
    <path
      fillRule='evenodd'
      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
    />
    <path d='M12.0002 5C9.67778 5 8.10531 6.77634 8.10531 9.13463C8.10531 11.874 9.92119 13.5754 12.0002 13.5754C14.0792 13.5754 15.8951 11.874 15.8951 9.13463C15.8951 6.77638 14.3226 5 12.0002 5ZM12.0002 14.8541C9.13732 14.8541 7.1911 15.8444 6.10542 17.1329C5.95451 17.3067 5.96703 17.5671 6.13392 17.7259C9.44622 20.7582 14.5541 20.758 17.8661 17.7254C18.033 17.5666 18.0455 17.3062 17.8945 17.1324C16.8087 15.8439 14.8628 14.8541 12.0002 14.8541Z' />
  </svg>
)

const IcoWallet = () => (
  <svg {...svgProps}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17 4C18.5 4 19 4.5 19 6L19 8C20.1046 8 21 8.89543 21 10L21 17C21 19 20 20 17.999 20H6C4 20 3 19 3 17L3 7C3 5.5 4.5 4 6 4L17 4ZM5 7C5 6.44772 5.44772 6 6 6L19 6L19 8L6 8C5.44772 8 5 7.55229 5 7ZM17 16C18 16 19.001 15 19 14C18.999 13 18 12 17 12C16 12 15 13 15 14C15 15 16 16 17 16Z'
    />
  </svg>
)

const IcoWarning = () => (
  <svg {...svgProps}>
    <path d='M 11.629 1.071 C 11.552 1.09 11.417 1.143 11.328 1.19 C 11.197 1.258 11.131 1.311 10.978 1.471 C 10.863 1.588 10.745 1.732 10.683 1.832 C 10.524 2.089 9.405 4.138 5.126 12.006 C 3.639 14.742 1.911 17.922 1.286 19.069 C 0.661 20.218 0.129 21.211 0.102 21.275 C -0.046 21.64 -0.033 22.044 0.138 22.366 C 0.166 22.421 0.258 22.534 0.341 22.62 C 0.511 22.795 0.673 22.891 0.915 22.961 L 1.057 23 L 12.086 22.996 L 23.117 22.99 L 23.269 22.938 C 23.95 22.696 24.196 21.964 23.839 21.225 C 23.8 21.141 22.153 18.142 20.179 14.558 C 18.206 10.976 15.85 6.698 14.943 5.051 C 14.035 3.404 13.238 1.968 13.169 1.861 C 12.947 1.516 12.666 1.254 12.383 1.133 C 12.148 1.032 11.872 1.008 11.629 1.071 Z M 14.643 7.724 C 16.131 10.422 18.431 14.597 19.754 17.001 L 22.16 21.371 L 17.073 21.377 C 14.274 21.379 9.693 21.379 6.892 21.377 L 1.798 21.371 L 4.924 15.625 C 10.904 4.628 11.912 2.782 11.929 2.803 C 11.936 2.811 13.157 5.026 14.643 7.724 Z' />

    <path d='M 11.796 7.638 C 11.769 7.644 11.681 7.665 11.6 7.687 C 10.869 7.878 10.276 8.612 10.276 9.32 C 10.276 9.409 10.317 9.815 10.37 10.219 C 10.42 10.623 10.582 11.891 10.726 13.04 C 11.103 16.035 11.1 16 11.131 16.125 C 11.21 16.447 11.396 16.704 11.64 16.829 C 11.765 16.894 11.801 16.903 11.955 16.909 C 12.24 16.923 12.416 16.851 12.608 16.644 C 12.794 16.439 12.878 16.207 12.938 15.739 C 12.959 15.575 13.052 14.837 13.146 14.098 C 13.238 13.36 13.392 12.155 13.484 11.415 C 13.578 10.678 13.672 9.94 13.692 9.776 C 13.737 9.421 13.739 9.181 13.7 9.021 C 13.546 8.391 13.024 7.853 12.4 7.683 C 12.259 7.644 11.901 7.618 11.796 7.638 Z' />

    <path d='M 11.856 17.656 C 11.208 17.742 10.741 18.38 10.82 19.073 C 10.858 19.397 10.981 19.66 11.203 19.873 C 11.417 20.081 11.647 20.185 11.936 20.204 C 12.287 20.226 12.567 20.113 12.827 19.84 C 13.079 19.578 13.188 19.307 13.189 18.932 C 13.191 18.706 13.165 18.575 13.081 18.386 C 12.855 17.877 12.37 17.588 11.856 17.656 Z' />
  </svg>
)

// remake
const IcoWarning2 = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 24' width='26' height='24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.2677 2C12.0375 0.666666 13.962 0.666667 14.7318 2L25.1241 20C25.8939 21.3333 24.9317 23 23.3921 23H2.60747C1.06787 23 0.105625 21.3333 0.875425 20L11.2677 2ZM11.9998 7.99995C11.9998 7.44767 12.4475 6.99995 12.9998 6.99995C13.552 6.99995 13.9998 7.44767 13.9998 7.99995V14C13.9998 14.5522 13.552 15 12.9998 15C12.4475 15 11.9998 14.5522 11.9998 14V7.99995ZM12.9998 19C13.552 19 13.9998 18.5522 13.9998 18C13.9998 17.4477 13.552 17 12.9998 17C12.4475 17 11.9998 17.4477 11.9998 18C11.9998 18.5522 12.4475 19 12.9998 19Z'
    />
  </svg>
)

// remake
const IcoWork = () => (
  <svg {...svgProps}>
    <path d='M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z' />
  </svg>
)

// remake
const IcoWorkOut = () => (
  <svg {...svgProps}>
    <path d='M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z' />
  </svg>
)

const IcoSun = () => (
  <svg viewBox='0 0 512 512' height='32' width='32'>
    <g>
      <circle cx='255.997' cy='255.997' r='144.824' fill='#FFD347' />
      <path
        fill='#FFD347'
        d='M256,56.849c-4.273,0-7.737-3.463-7.737-7.737V7.737C248.263,3.463,251.727,0,256,0
		s7.737,3.463,7.737,7.737v41.376C263.737,53.386,260.273,56.849,256,56.849z'
      />
      <path
        fill='#FFD347'
        d='M152.563,84.568c-2.674,0-5.274-1.387-6.707-3.869l-20.687-35.832
		c-2.136-3.7-0.869-8.432,2.832-10.569c3.701-2.134,8.432-0.87,10.569,2.832l20.687,35.832c2.136,3.7,0.869,8.432-2.832,10.569
		C155.206,84.234,153.876,84.568,152.563,84.568z'
      />
      <path
        fill='#FFD347'
        d='M76.823,160.294c-1.312,0-2.643-0.334-3.861-1.038L37.13,138.569
		c-3.7-2.136-4.968-6.868-2.832-10.569c2.136-3.701,6.868-4.967,10.569-2.832l35.832,20.687c3.7,2.136,4.968,6.868,2.832,10.569
		C82.097,158.907,79.497,160.294,76.823,160.294z'
      />
      <path
        fill='#FFD347'
        d='M49.112,263.737H7.737C3.464,263.737,0,260.274,0,256s3.464-7.737,7.737-7.737h41.376
		c4.273,0,7.737,3.463,7.737,7.737S53.385,263.737,49.112,263.737z'
      />
      <path
        fill='#FFD347'
        d='M41.005,387.869c-2.674,0-5.274-1.387-6.707-3.869c-2.136-3.7-0.869-8.432,2.832-10.569
		l35.832-20.687c3.7-2.134,8.432-0.87,10.569,2.832c2.136,3.7,0.869,8.432-2.832,10.569l-35.832,20.687
		C43.648,387.535,42.317,387.869,41.005,387.869z'
      />
      <path
        fill='#FFD347'
        d='M131.862,478.74c-1.312,0-2.643-0.334-3.861-1.038c-3.7-2.136-4.968-6.868-2.832-10.569
		l20.687-35.832c2.136-3.701,6.868-4.967,10.569-2.832c3.7,2.136,4.968,6.868,2.832,10.569l-20.687,35.832
		C137.136,477.352,134.536,478.74,131.862,478.74z'
      />
      <path
        fill='#FFD347'
        d='M256,512c-4.273,0-7.737-3.463-7.737-7.737v-41.376c0-4.274,3.464-7.737,7.737-7.737
		s7.737,3.463,7.737,7.737v41.376C263.737,508.537,260.273,512,256,512z'
      />
      <path
        fill='#FFD347'
        d='M380.138,478.74c-2.674,0-5.274-1.387-6.707-3.869l-20.687-35.832
		c-2.136-3.7-0.869-8.432,2.832-10.569c3.7-2.134,8.432-0.87,10.569,2.832l20.687,35.832c2.136,3.7,0.869,8.432-2.832,10.569
		C382.781,478.406,381.451,478.74,380.138,478.74z'
      />
      <path
        fill='#FFD347'
        d='M470.995,387.869c-1.312,0-2.643-0.334-3.861-1.038l-35.832-20.687
		c-3.7-2.136-4.968-6.868-2.832-10.569c2.136-3.701,6.868-4.967,10.569-2.832l35.832,20.687c3.7,2.136,4.968,6.868,2.832,10.569
		C476.269,386.481,473.669,387.869,470.995,387.869z'
      />
      <path
        fill='#FFD347'
        d='M504.263,263.737h-41.376c-4.273,0-7.737-3.463-7.737-7.737s3.464-7.737,7.737-7.737h41.376
		c4.273,0,7.737,3.463,7.737,7.737S508.536,263.737,504.263,263.737z'
      />
      <path
        fill='#FFD347'
        d='M435.177,160.294c-2.674,0-5.274-1.387-6.707-3.869c-2.136-3.7-0.869-8.432,2.832-10.569
		l35.832-20.687c3.7-2.134,8.432-0.87,10.569,2.832c2.136,3.7,0.869,8.432-2.832,10.569l-35.832,20.687
		C437.82,159.96,436.489,160.294,435.177,160.294z'
      />
      <path
        fill='#FFD347'
        d='M359.437,84.568c-1.312,0-2.643-0.334-3.861-1.038c-3.7-2.136-4.968-6.868-2.832-10.569
		l20.687-35.832c2.136-3.701,6.868-4.967,10.569-2.832c3.7,2.136,4.968,6.868,2.832,10.569l-20.687,35.832
		C364.711,83.181,362.11,84.568,359.437,84.568z'
      />
    </g>
    <path
      fill='#FFBE31'
      d='M256,111.18c-5.242,0-10.418,0.286-15.516,0.828c72.685,7.743,129.303,69.252,129.303,143.991
	s-56.619,136.249-129.303,143.992c5.098,0.544,10.273,0.828,15.516,0.828c79.982,0,144.82-64.838,144.82-144.82
	S335.983,111.18,256,111.18z'
    />
  </svg>
)

const iconArray: { [key: string]: JSX.Element } = {
  add_o: <IcoAddOut />,
  arrows: <IcoArrows />,
  arr_down: <IcoArrDown />,
  apartment: <IcoApartment />,
  backup: <IcoBackUp />,
  bots: <IcoBots />,
  caution: <IcoCaution />,
  close: <IcoClose />,
  check: <IcoCheck />,
  check2: <IcoCheck2 />,
  description: <IcoDescription />,
  document: <IcoDocument />,
  error: <IcoError />,
  folder_o: <IcoFolderOut />,
  github: <IcoGitHub />,
  key: <IcoKey />,
  languages: <IcoLanguages />,
  logout: <IcoLogout />,
  logout2: <IcoLogout2 />,
  menu: <IcoMenu />,
  metamask: <IcoMetamask />,
  money: <IcoMoney />,
  more: <IcoMore />,
  moon: <IcoMoon />,
  info: <IcoNotification />,
  search: <IcoSearch />,
  settings: <IcoSettings />,
  settings_mob: <IcoSettingsMob />,
  sorting: <IcoSorting />,
  splash: <IcoSplash />,
  storage: <IcoStorage />,
  statistic: <IcoStatistic />,
  subject: <IcoSubject />,
  success: <IcoSuccess />,
  tultip: <IcoTultip />,
  user: <IcoUser />,
  wallet: <IcoWallet />,
  warning: <IcoWarning />,
  warning2: <IcoWarning2 />,
  work: <IcoWork />,
  work_out: <IcoWorkOut />,
  sun: <IcoSun />,
}
export default iconArray
